export const DASHBOARD_DATA = 'DASHBOARD_DATA'
export const DASHBOARD_TASK_DATA = 'DASHBOARD_TASK_DATA'
export const WORKSHIFT_DATA = 'WORKSHIFT_DATA'
export const UKG_DATA = 'UKG_DATA'
export const EMPLOYEE_DATA = 'EMPLOYEE_DATA'
export const WORKSHIFT_DATA_SIDEBAR = 'WORKSHIFT_DATA_SIDEBAR'
export const ATTENDANTS_FOR_SORTING = 'ATTENDANTS_FOR_SORTING'
export const WORKSHIFT_DATA_BY_ID = 'WORKSHIFT_DATA_BY_ID'
export const STEPPER_POSITION = 'STEPPER_POSITION'
